(() => {
  const normalizeTitle = (value) =>
    String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/\s+/g, '')
      .replace(/[^\p{L}\p{N}]/gu, '');

  const normalizePath = (value) => {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.origin);
      let path = url.pathname.replace(/\/+$/, '') || '/';
      path = path.replace(/^\/[a-z]{2}(?=\/)/i, '');
      return path || '/';
    } catch (error) {
      return String(value).replace(/[?#].*$/, '').replace(/\/+$/, '');
    }
  };

  const getControlTitle = (control) => {
    if (!control) return '';
    const clone = control.cloneNode(true);
    clone.querySelectorAll('svg, .icon__fallback-text').forEach((node) => node.remove());
    return clone.textContent.replace(/\s+/g, ' ').trim();
  };

  const getControlUrl = (control) => {
    if (!control) return '';
    return control.getAttribute('data-link') || control.getAttribute('href') || '';
  };

  const buildConfigs = (selector) =>
    Array.from(document.querySelectorAll(selector)).map((template) => ({
      template,
      title: normalizeTitle(template.dataset.animepaTrigger),
      path: normalizePath(template.dataset.animepaTargetUrl)
    }));

  const findConfig = (path, title, configs) =>
    configs.find((entry) =>
      (entry.path && path && entry.path === path) ||
      (entry.title && title && entry.title === title)
    );

  const refreshDesktopMenus = (desktopConfigs) => {
    document.querySelectorAll('#SiteHeader .site-nav.site-navigation').forEach((nav) => {
      Array.from(nav.children).forEach((item) => {
        if (!item.classList.contains('site-nav__item')) return;

        const details = item.querySelector(':scope > details.site-nav__details');
        if (!details) return;

        const control = details.querySelector(':scope > summary.site-nav__link');
        const itemTitle = normalizeTitle(getControlTitle(control));
        const itemPath = normalizePath(getControlUrl(control));
        const config = findConfig(itemPath, itemTitle, desktopConfigs);
        if (!config) return;

        const fragment = config.template.content.cloneNode(true);
        const replacement = fragment.firstElementChild;
        if (!replacement) return;

        const existingDropdown =
          details.querySelector(':scope > .animepa-mm-dropdown') ||
          details.querySelector(':scope > .site-nav__dropdown');

        item.classList.add('site-nav--has-dropdown', 'site-nav--is-megamenu', 'animepa-native-mega');

        if (existingDropdown) existingDropdown.replaceWith(replacement);
        else details.appendChild(replacement);
      });
    });
  };

  const makeAutoMobileList = (desktopConfig) => {
    if (!desktopConfig) return null;
    const sourceLinks = Array.from(
      desktopConfig.template.content.querySelectorAll('.animepa-mm-categories .animepa-mm-link')
    );
    if (!sourceLinks.length) return null;

    const list = document.createElement('ul');
    list.className = 'mobile-nav__sublist animepa-mobile-mm-list';

    sourceLinks.forEach((sourceLink) => {
      const li = document.createElement('li');
      li.className = 'mobile-nav__item';
      const link = document.createElement('a');
      link.className = 'mobile-nav__link';
      link.href = sourceLink.href;
      link.textContent = sourceLink.textContent.trim();
      li.appendChild(link);
      list.appendChild(li);
    });

    return list;
  };

  const refreshMobileMenus = (desktopConfigs, mobileConfigs) => {
    const drawer = document.querySelector('#NavDrawer');
    if (!drawer) return;

    drawer.querySelectorAll(':scope .mobile-nav > .mobile-nav__item').forEach((item) => {
      const topWrap = item.querySelector(':scope > .mobile-nav__has-sublist');
      const topAnchor = topWrap && topWrap.querySelector(':scope > a.mobile-nav__link--top-level');
      const topButton = topWrap && topWrap.querySelector(':scope > button.mobile-nav__link--top-level');
      const control = topAnchor || topButton;
      if (!control) return;

      const itemTitle = normalizeTitle(getControlTitle(control));
      const itemPath = normalizePath(getControlUrl(control));
      const mobileConfig = findConfig(itemPath, itemTitle, mobileConfigs);
      const desktopConfig = findConfig(itemPath, itemTitle, desktopConfigs);
      if (!mobileConfig && !desktopConfig) return;

      const inner = item.querySelector(':scope > .mobile-nav__sublist.collapsible-content > .collapsible-content__inner');
      if (!inner) return;

      if (mobileConfig) {
        const fragment = mobileConfig.template.content.cloneNode(true);
        if (!fragment.childNodes.length) return;
        inner.replaceChildren(fragment);
        item.classList.add('animepa-mobile-mega');
        return;
      }

      const autoList = makeAutoMobileList(desktopConfig);
      if (!autoList) return;
      inner.replaceChildren(autoList);
      item.classList.add('animepa-mobile-mega');
    });
  };

  const refreshMegaMenus = () => {
    const desktopConfigs = buildConfigs('template[data-animepa-mm-template]');
    const mobileConfigs = buildConfigs('template[data-animepa-mobile-template]');
    if (!desktopConfigs.length && !mobileConfigs.length) return;

    refreshDesktopMenus(desktopConfigs);
    refreshMobileMenus(desktopConfigs, mobileConfigs);
  };

  let refreshTimer;
  const scheduleRefresh = (delay = 0) => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshMegaMenus, delay);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleRefresh(0), { once: true });
  } else {
    scheduleRefresh(0);
  }

  window.addEventListener('load', () => scheduleRefresh(0), { once: true });
  document.addEventListener('animepa:mega-manager:refresh', () => scheduleRefresh(0));
  document.addEventListener('shopify:section:load', () => scheduleRefresh(30));
  document.addEventListener('shopify:section:reorder', () => scheduleRefresh(30));
  document.addEventListener('shopify:block:select', () => scheduleRefresh(30));

  scheduleRefresh(350);
})();